<template>
    <toolbar-option>
        <template slot="primary">
            <button class="button" @click="showModal('modal-dynamic-options')">
                MANAGE
            </button>
        </template>
    </toolbar-option>
</template>

<script>
import { mapMutations } from 'vuex';

import baseOption from '@/options/mixins/base-option';
import { SHOW_MODAL } from '@/store/types/mutation-types';

export default {
    name: 'dynamic-collection',

    mixins: [baseOption],

    data() {
        return {
            displayName: 'Dynamic Collection',
        };
    },

    methods: {
        ...mapMutations({
            showModal: SHOW_MODAL,
        }),
    },
};
</script>

<style lang="scss" scoped>
.button {
    @extend %button-alt;
    @extend %button-compact;
}
</style>
